var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instagram-slider relative"},[_vm._m(0),_c('carousel',{attrs:{"autoplay":false,"autoHeight":true,"items":_vm.InstagramSlidercontent.itemPerSlide,"margin":0,"dots":false,"loop":true,"nav":false,"mouseDrag":false,"responsive":{
                0:{
                    items:3,
                    mouseDrag: true
                },
                750:{
                    items:5,
                    mouseDrag: false
                },

            }}},_vm._l((_vm.InstagramSlidercontent.instagramItems),function(InstagramSlide,i){return _c('div',{key:i,staticClass:"instagram-slide"},[_c('a',{attrs:{"href":InstagramSlide.url ? InstagramSlide.url : '#'}},[_c('img',{attrs:{"src":InstagramSlide.img,"alt":"Instagram"}})])])}),0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"home-instagram__hashtag inline-block text-base font-medium absolute"},[_vm._v(" Get "),_c('a',{attrs:{"href":"https://instagram.com/"}},[_vm._v("#readyjudy")])])}]

export { render, staticRenderFns }